import React, { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import img1 from '../images/lucky.png'
import charmImage from '../images/charm.png';
import { useLotteryData } from '../data/useLotteryData';
import {
  forecastJackpotMilestones,
  formatForecastWindow
} from '../data/jackpotForecast';


function Powerball(props) {
    const navigate = useNavigate();
    const game = props.select.classCalled === 'megaImage' ? 'mega-millions' : 'powerball';
    const dropGame = game === 'mega-millions' ? 'mega' : 'powerball';
    const { data: responseData, loading } = useLotteryData(game);
    const [selectedTab, setSelectedTab] = useState('history');
    const [numbers, setNumbers] = useState(Array(6).fill(null));

    const handleTabClick = (tab) => {
      setSelectedTab(tab);
    };

    const handleBackClick = () => {
      navigate(game === 'mega-millions' ? '/mega' : '/powerball');
    };

    const handleCharmClick = () => {
      navigate('/drop', { state: { game: dropGame, dropEntryVersion: 2 } });
    };

    function generateNumbers() {
      let newNumbers = [];
      for (let i = 0; i < 5; i++) {
        newNumbers.push(Math.floor(Math.random() * (props.select.classCalled === 'powerballImage' ? 69 : 70)) + 1);
      }
      newNumbers.push(Math.floor(Math.random() * (props.select.classCalled === 'powerballImage' ? 26 : 25)) + 1);
      setNumbers(newNumbers);
    }

    const apiData = useMemo(() => {
      let lotteryData = [];
      if (responseData?.PreviousDraws?.length >= 6) {
        for (let y = 0; y < 6; y++) {
          let result = "";
          for (let i = 0; i < 6; i++) {
            if (i === 5) {
              result += "<b>" + responseData.PreviousDraws[y].WinningNumbers[i].Number + "</b> ";
            } else {
              result += responseData.PreviousDraws[y].WinningNumbers[i].Number + ", " ;
            }
          }
          let drawDate = new Date(responseData.PreviousDraws[y].DrawDate);
          drawDate = drawDate.toLocaleString("en-US", { month: "long", day: "numeric" });
          result += '&nbsp;&nbsp;&nbsp;&nbsp;' + drawDate;
          lotteryData.push(result);
        }
      }
      return lotteryData;
    }, [responseData]);

    const jackpotForecast = useMemo(() => forecastJackpotMilestones({
      game,
      currentJackpot: responseData?.NextDraw?.JackpotAmount,
      nextDrawAt: responseData?.NextDraw?.DrawDate,
      history: responseData?.JackpotHistory
    }), [game, responseData]);

      return (
        <div className="wrapper">
          <button
            aria-label="Open Lucky Drop game"
            className="charmPortalButton"
            onClick={handleCharmClick}
            type="button"
          >
            <img alt="" className="charmPortalImage" src={charmImage} />
          </button>
          <Link className='clickableText' to="/"><h1>{props.select.classCalled === 'powerballImage' ? 'POWERBALL' : 'Mega Millions'}</h1></Link>
          <button type="button" className="detailBackButton" onClick={handleBackClick}>Back</button>
          {loading ? (
            <div className="loadingContainerData">
              <img src={img1} className="luckyNumbers spinAnimation" alt="loading" />
            </div>
          ) : (
            <div>
              <div className="navContainer">
                <p className={`navBar ${selectedTab === 'estimator' ? 'active' : ''}`} onClick={() => handleTabClick('estimator')}>Generator</p>
                <p className={`navBar ${selectedTab === 'history' ? 'active' : ''}`} onClick={() => handleTabClick('history')}>History</p>
                <p className={`navBar ${selectedTab === 'generator' ? 'active' : ''}`} onClick={() => handleTabClick('generator')}>Estimator</p>
                {/* learn ${selectedTab === 'Estimator' ? 'active' : ''} */}
              </div>
              {selectedTab === 'estimator' ? (
                <div className="dataContentWrapper">
                  <ul className="numberContents">
                    {numbers.map((number, index) => (
                      <li key={index}>
                        {number === null ? (
                          <img alt="" className="generatorCharmImage" src={charmImage} />
                        ) : index === 5 ? <b>{number}</b> : number}
                      </li>
                    ))}
                  </ul>
                  <button onClick={generateNumbers}>Generate Numbers</button>
                </div>
              ) : selectedTab === 'history' ? (
                <div className="dataContentWrapper">
                  <p className="dataPtags" dangerouslySetInnerHTML={{__html: apiData[0]}}></p>
                  <p className="dataPtags" dangerouslySetInnerHTML={{__html: apiData[1]}}></p>
                  <p className="dataPtags" dangerouslySetInnerHTML={{__html: apiData[2]}}></p>
                  <p className="dataPtags" dangerouslySetInnerHTML={{__html: apiData[3]}}></p>
                  <p className="dataPtags" dangerouslySetInnerHTML={{__html: apiData[4]}}></p>
                  <p className="dataPtags" dangerouslySetInnerHTML={{__html: apiData[5]}}></p>
                </div>
              ) : (
                <div className="dataContentWrapper">
                  <p className="dataPtags" style={{ marginBottom: '35px'}}>Jackpot: <span style={{ color: 'green'}}><b>{formatCurrency(responseData?.NextDraw?.JackpotAmount)}</b></span></p>
                  {jackpotForecast.milestones.map((milestone) => (
                    <p className="dataPtags" key={milestone.target}>
                      {formatMilestone(milestone.target)}: {formatForecastWindow(milestone)}
                    </p>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      );
}

export default Powerball

function formatCurrency(value) {
  return Number.isFinite(value)
    ? value.toLocaleString('en-US', {style: 'currency', currency: 'USD'}).replaceAll(' ', '').replace(/\.00$/, '')
    : '';
}

function formatMilestone(value) {
  return value >= 1_000_000_000
    ? `${value / 1_000_000_000} Billion`
    : `${value / 1_000_000} Million`;
}
